import React, { useState } from 'react';

import { MultiSelect } from 'primereact/multiselect';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from "primereact/dropdown";
import { Dialog } from 'primereact/dialog';
import "../components/hubIntegrationsMenu.scss";
import "./apiConfigurationForm.scss";
import 'primeflex/primeflex.scss';


import focco from "../../../assets/images/integrationIcons/focco.png";
import agile from "../../../assets/images/integrationIcons/agile.png";
import fullsoft from "../../../assets/images/integrationIcons/fullsoft.jpeg";
import google from "../../../assets/images/integrationIcons/google.jpg";
import pressier from "../../../assets/images/integrationIcons/pressier.jpg";
import promob from "../../../assets/images/integrationIcons/promob.png";
import sankhya from "../../../assets/images/integrationIcons/sankhya.png";
import sap from "../../../assets/images/integrationIcons/sap.png";
import totvs from "../../../assets/images/integrationIcons/totvs.jpg";





export const ApiConfigurationForm = (props) => {

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const handleGenerateCredentials = () => {
    if (props.credentials?.accountId || props.credentials?.accountKey) {
      setShowConfirmDialog(true);
    } else {
      props.onGenerateCredentialsAPI();
    }
  };

  const confirmDialogFooter = (
    <div>
      <button
        title="Confirmar"
       className="lognex-btn-highlighted" 
       onClick={() => {
        setShowConfirmDialog(false);
        props.onGenerateCredentialsAPI();
      }}>
        <i className="pi pi-check"></i>
      </button>
      <button
        title="Cancelar"
        className="lognex-btn-danger"
        onClick={() => setShowConfirmDialog(false)}
        style={{ marginLeft: '10px' }}
      >
        <i className="pi pi-times"></i>
      </button>
    </div>
  );

  return (

    <div className="p-grid" style={{ marginTop: "20px" }}>
      <div className="p-col-2">
        <label htmlFor="accountId">Account ID</label>
          <div className="p-inputgroup">

            <InputText
              id="accountId"
              value={props.credentials?.accountId || ''}
              readOnly
              className="p-inputtext-lg"
              style={{ width: 'calc(100% - 40px)', height: '40px' }}
            />
            <button
              onClick={() => navigator.clipboard.writeText(props.credentials?.accountId || '')}
              style={{ height: '40px', width: '40px', marginLeft: '10px' }}
            >
              <i className="pi pi-copy" style={{ marginRight: '0.5rem', fontSize: '2.0rem' }}></i>
            </button>
          </div>
      </div>

      <div className="p-col-12"></div>

      <div className="p-col-6">
        <label htmlFor="accountKey">Account Key</label>
        <div className="p-inputgroup">
          <InputText
            id="accountKey"
            value={props.credentials?.accountKey || ''}
            readOnly
            className="p-inputtext-lg"
              style={{ width: 'calc(100% - 40px)', height: '40px' }}
            />
            <button
              onClick={() => navigator.clipboard.writeText(props.credentials?.accountKey || '')}
              style={{ height: '40px', width: '40px', marginLeft: '10px' }}
            >
              <i className="pi pi-copy" style={{ marginRight: '0.5rem', fontSize: '2.0rem' }}></i>
            </button>
          </div>
      </div>

      {
        props.messageError && props.messageError !== "" && (
          <div className="p-col-12" style={{ marginTop: '1rem' }}>
            <div className="p-field">
              <h3 id="messageError" style={{ color: 'red' }}>{props.messageError}</h3>
            </div>
          </div>
        )
      }

      <div className="p-col-12" style={{ marginTop: '1rem', display: 'flex', gap: '1rem' }}>
        <button
          className="lognex-btn-highlighted-inverse custom-button"
          onClick={handleGenerateCredentials}
        >
          <i className="pi pi-key" style={{ marginRight: '0.5rem', fontSize: '1.5rem' }}></i>
          Gerar Credenciais de Acesso
        </button>

        <button
          className="lognex-btn-highlighted-inverse custom-button"
          onClick={() => window.open("https://tms.lognex.com.br/docs/", "_blank")}
        >
          <i className="pi pi-search" style={{ marginRight: '0.5rem', fontSize: '1.5rem' }}></i>
          Acessar APIs
        </button>
      </div>

    

     

      <Dialog
        visible={showConfirmDialog}
        onHide={() => setShowConfirmDialog(false)}
        header="Confirmar Alteração"
        footer={confirmDialogFooter}
        style={{ width: '450px' }}
      >
        <h3>Existem credenciais já cadastradas. Deseja alterá-las?</h3>
      </Dialog>
    </div >
  )
}